<template>
  <sp-button
    class="sp-table-sort-button"
    part="sort"
    variant="text"
    size="xx-small"
    :accessible-name="ariaLabel"
    @click="emit('sort')"
  >
    {{ label }}
    <sp-icon v-if="active" slot="append" :name="icon" size="xx-small"></sp-icon>
  </sp-button>
</template>

<script setup>
import { computed } from "vue";

import { t } from "#ce/shared/components-i18n";

const props = defineProps({
  label: {
    type: String,
    default: "",
  },
  /**
   * The table is sorted by this column, so the direction indicator shows.
   */
  active: {
    type: Boolean,
    default: false,
  },
  /**
   * Direction of the current sort, "asc" or "desc".
   */
  direction: {
    type: String,
    default: "desc",
  },
});

const emit = defineEmits(["sort"]);

const icon = computed(() => (props.direction === "asc" ? "chevron-up" : "chevron-down"));
const ariaLabel = computed(() => t("table_sort_by", { label: props.label }));
</script>

<style lang="scss" scoped>
.sp-table-sort-button {
  --sp-comp-button-xx-small-padding: 0;
}
</style>
